export enum ItemToDelete {
  candidate = 'candidate',
  user = 'user',
  jobPosition = 'job position',
}
